"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchWrapper = exports.SearchInput = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SearchWrapper = exports.SearchWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__SearchWrapper",
  componentId: "bufferapp-ui__sc-1a69v26-0"
})(["height:auto;width:100%;margin-left:8px;"]);
const SearchInput = exports.SearchInput = /*#__PURE__*/_styledComponents.default.input.withConfig({
  displayName: "style__SearchInput",
  componentId: "bufferapp-ui__sc-1a69v26-1"
})(["&&{border:0;border-radius:4px;box-shadow:none;width:100%;box-sizing:border-box;resize:none;font-size:14px;height:", ";padding-left:0px;&:focus{outline:none;}}"], props => props.height === 'small' ? '28px' : '48px');